import React, { useState, useEffect } from "react";
import "./transfer.scss";
import Form from "./Form";
import Controller from "./Controller";
import Finish from "./Finish";
import { useGetMainQuery } from "services/clientApi";
import { useSelector } from "react-redux";

const Transfer = ({ setIsHistory }) => {
  const { data: main, isError: error } = useGetMainQuery();
  const [transactionStep, setTransactionStep] = useState("step-1");
  const [isMobile, setIsMobile] = useState("");
  const [attentionData, setAttentionData] = useState("");
  const screenWidth = useSelector((state) => state?.common?.screenWidth);

  useEffect(() => {
    setIsMobile(["lg", "md", "sm", "xs"].includes(screenWidth));
  }, [screenWidth]);


  return (
    <div className="border h-100 bg-white p-3 rounded">
      <div className="text-end">
        {isMobile && (
          <button
            onClick={() => setIsHistory(true)}
            className="btn btn-primary btn-sm mt-2 rounded fw-bold"
          >
            <i className="fa-solid fa-clock-rotate-left me-2"></i>
            History
          </button>
        )}
      </div>


      {!["xs", "sm", "md"].includes(screenWidth) && (
        <Controller
          hasAccess={!(main?.user?.detail?.allow_transfer === false)}
          transactionStep={transactionStep}
        />
      )}

      {main?.user?.detail?.allow_transfer === false ? (
        <>
          <div className="py-4 my-4">
            <div className="text-center mb-5">
              <h5 className="text-danger fw-bold">
                <i className="fa-solid fa-triangle-exclamation me-2"></i>
                Transfer Restrictions! Our Team will Reach Out Shortly.
              </h5>
            </div>
          </div>
        </>
      ) : (
        transactionStep === "step-1" || transactionStep === "step-2" || transactionStep === "step-3" ? (
          <Form
            setAttentionData={setAttentionData}
            setTransactionStep={setTransactionStep}
            transactionStep={transactionStep}
            main={main}
          />
        ) : (
          <Finish attentionData={attentionData} />
        )
      )}
    </div>
  );
};

export default Transfer;
